<template>
    <div>
        <v-form ref="newEmailForm" v-model="newEmailFormValid" lazy-validation>
            <v-card>
                <v-card-text>
                    <v-layout wrap> 
                        <v-flex xs12>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="emailData.name" 
                                label="Name"
                                ></v-text-field>

                        </v-flex>
                        <v-flex xs12>
                            <v-text-field 
                                :rules="emailRules"
                                v-model="emailData.email" 
                                label="Email"
                                ></v-text-field>

                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat="flat" @click.native="onAddNewEmail">Done</v-btn>
                    <v-btn color="green darken-1" flat="flat" @click.native="onCloseAddNewEmail">Close</v-btn>
                </v-card-actions>

            </v-card>
        </v-form>

    </div>
</template>
<script>

export default {
    data () {
        return {
            emailData: {},
            rules: {
                required: v => !!v || "This field is required"
            },
            emailRules: [
                (v) => !!v || 'E-mail is required',
                (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
            ],
            newEmailFormValid: false,
        }
    },
    computed: {
        title () {
            return "Add New Email"
        },
    },
    methods: {
        onAddNewEmail(user) {
            if (this.$refs.newEmailForm.validate()) {
                var email = Object.assign({}, this.emailData)
                console.log(email)
                this.$emit('onAddNewEmail', email)
                //reset
                this.emailData = {}
            }
        },
        onCloseAddNewEmail() {
            this.$emit('onCloseAddNewEmail')
            //reset
            this.emailData = {}
        }
    },
}
</script>
